var App = App || {};

App.ZagScrollAnimate = (function ($) {
    'use strict';

    function Init() {

        $(".widget-stories").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".widget-stories-panes .tab-pane:first-child .story-layout", type: "animate__fadeInUp", stagger: 0 }
            ]
        });

        $(".widget-icons").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".item-icon", type: "animate__fadeInUp", stagger: 200 }
            ]
        });

        $(".widget-carousel .widget-carousel-slides").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".splide", type: "animate__fadeInRight", stagger: 0 }
            ],
            overflow: true
        });

        $(".widget-cards .widget-cards-items").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".shared-item-card", type: "animate__fadeInUp", stagger: 200 }
            ]
        });

        $(".widget-crossPromos").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".widget-crossPromos-carousel", type: "animate__fadeInRight", stagger: 0 }
            ],
            overflow: true
        });

        $(".component-contactBand").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".contactBand-navItem", type: "animate__fadeInUp", stagger: 200 }
            ]
        });

        $(".widget-masthead").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".widget-masthead-layout", type: "animate__fadeInUp", stagger: 0 }
            ]
        });

        $(".widget-features").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".item-feature", type: "animate__fadeInUp", stagger: 200 }
            ]
        });

        $(".widget-quickLinks").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".widget-quickLinks-image", type: "animate__fadeInLeft", stagger: 0 }
            ]
        });

        $(".widget-subpages .widget-subpages-cards").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".widget-subpage-card", type: "animate__fadeInUp", stagger: 200 }
            ]
        });

        $(".widget-news .widget-news-items").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".shared-item-card", type: "animate__fadeInUp", stagger: 200 }
            ]
        });

        $(".widget-promos .widget-promos-items").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".item-promo", type: "animate__fadeInUp", stagger: 200 }
            ]
        });

        $(".widget-videos .item-video").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".item-video-layout", type: "animate__fadeInUp", stagger: 0 }
            ]
        });

        $(".widget-videoLibrary .widget-videoLibrary-group").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".widget-videoLibrary-group-layout", type: "animate__fadeInUp", stagger: 0 }
            ]
        });

        $(".widget-testimonial").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".item-testimonial", type: "animate__fadeInUp", stagger: 0 }
            ]
        });

        $(".widget-education").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".item-education", type: "animate__fadeInUp", stagger: 0 }
            ]
        });

        $(".widget-bios .widget-bios-items").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".item-bio-card", type: "animate__fadeInUp", stagger: 200 }
            ]
        });
    }

    return {
        Init: Init
    };

})(jQuery);

$(function () {
    App.ZagScrollAnimate.Init();
});